import { Draft, produce } from 'immer';

import { FeatureType } from '@app/features/subscription/types/FeatureType';
import {
  USER_AUTHORITY__FETCH_SUCCESS,
  USER_AUTHORITY__INITIALIZE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { UserAuthorityAction } from '@app/store/user/authority/actions';
import LimitType from '@app/store/user/authority/LimitType';

type Limit = {
  count: number;
  feature: FeatureType;
  id: string | null;
  type: LimitType | null;
};

export type UserAuthorityLimitState = {
  [K in FeatureType]: null | Limit;
};

const initialState: UserAuthorityLimitState = {
  [FeatureType.API_SIGNING_REQUEST_COUNT]: null,
  [FeatureType.ATTACHMENT_REQUEST_COUNT]: null,
  [FeatureType.BULK_REQUEST_COUNT]: null,
  [FeatureType.CONTRACT_LINK_COMPLETED_DOCUMENT_COUNT]: null,
  [FeatureType.DOCUMENT_COUNT]: null,
  [FeatureType.EXTERNAL_DOCUMENT_COUNT]: null,
  [FeatureType.KAKAO_NOTIFICATION_COUNT]: null,
  [FeatureType.MOBILE_VERIFICATION_COUNT]: null,
  [FeatureType.WORKSPACE_SEAT_COUNT]: null,
  [FeatureType.SIGNING_REQUEST_COUNT]: null,
  [FeatureType.TEMPLATE_COUNT]: null,
  [FeatureType.SIGNER_COUNT]: null,
};

const reducer = produce((draft: Draft<UserAuthorityLimitState>, action: UserAuthorityAction) => {
  switch (action.type) {
    case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS:
    case USER_AUTHORITY__FETCH_SUCCESS: {
      Object.values(FeatureType).forEach((key) => {
        draft[key] = null;
      });
      if (action.payload) {
        const { limits } = action.payload;
        limits.forEach(({ count, feature, id, type }) => {
          draft[feature] = { count, feature, id, type };
        });
      } else {
        /**
         * 특정 featureType의 limit 상태가 null이면 제한량이 없다는 것(Infinity)을 의미합니다.
         * limit 상태의 count가 0인 것은 해당 featureType에 대한 할당량이 없음을 의미합니다.
         * 권한이 아예 없는 유저는 해당 기능을 사용할 수 없음을 상태에 드러내기 위해  limit.count를 0으로 업데이트합니다.
         */
        Object.values(FeatureType).forEach((key) => {
          draft[key] = {
            count: 0,
            feature: key,
            id: null,
            type: null,
          };
        });
      }
      return draft;
    }
    case USER_AUTHORITY__INITIALIZE:
      return initialState;
    default:
      return draft;
  }
}, initialState);

export default reducer;
